"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GranteeListLoading = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var LoadingMask_1 = require("../../../LoadingMask");
/**
 * @internal
 */
exports.GranteeListLoading = function () {
    return (react_1.default.createElement("div", { className: "gd-share-dialog-grantee-list-empty-selection" },
        react_1.default.createElement(LoadingMask_1.LoadingMask, { size: "large" })));
};
//# sourceMappingURL=GranteeListLoading.js.map